
import React, { Component } from 'react';
import { Modal, Form, Input, Tabs, Row, Col, Switch, InputNumber, DatePicker, Select } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import validator from '../../../util/validator';
import ocr from '../../../util/ocr';
import Loading from '../../ui/Loading';

import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';
import Image from '../../ui/Image';
import Scanner from '../../ui/Scanner';
//会员选择
import MemberSelect from '../../crm/member/MemberSelect';
import MemberUserSelect from '../../crm/member/MemberUserSelect';

//转成数字
// import { fixedNumber } from '../../../util/util';


import '../../../style/common/uploadImage.css';
const FormItem = Form.Item;

//车辆信息
const vehicleField = [{
  "text": "登记证书编号",
  "field": "vehicleBaseObj_registerNo", //新增采销订单
  rules: [
    { required: true, message: '登记证书编号不能为空！' },
    { max: 12, message: '登记证书编号为12位数字！' },
    { min: 12, message: '登记证书编号为12位数字！' },
    validator.num
  ]
}, {
  "text": "公里数/公里",
  "field": "vehicleBaseObj_mileage",//新增采销订单
  rules: [
    { required: true, message: '公里数不能为空！' },
    { pattern: /^[0-9]+$/, message: '只能输入数字!' }
  ]
}, {
  "text": "车主名称",
  "field": "vehicleBaseObj_owner",//????
  rules: [
    { required: true, message: '车主名称不能为空！' }
  ]
}, {
  "text": "年检时间有效期",
  "field": "vehicleBaseObj_examinationValidTime",//新增采销订单
  date: true,
  rules: [
    { required: true, message: '年检时间有效期不能为空!' },
  ]
}, {
  "text": "车牌号",
  "field": "vehicleBaseObj_plateNo",//新增采销订单
  rules: [
    { required: true, message: '车牌号码不能为空!' },
    validator.plateNo
  ]
}, {

  "text": "车辆类型",
  "field": "vehicleBaseObj_vehicleType",
  "category": "VEHICLE_TYPE",
  select: true,
  needPull: true,
  rules: [
    { required: true, message: '车辆类型不能为空!' }
  ]
}, {
  "text": "商业保险有效期",
  "field": "vehicleBaseObj_commerciaInsuranceTime",//新增采销订单
  date: true
}, {
  "text": "厂牌型号",
  "field": "vehicleBaseObj_vehicleName",//保存合同
  rules: [
    { required: true, message: '厂牌型号不能为空!' },
    { max: 64, message: '厂牌型号不能超过64个字符！' },
  ]
}, {
  "text": "保险费缴有效期至",
  "field": "vehicleBaseObj_insurancePayTime",//新增采销订单
  date: true,
  rules: [
    { required: true, message: '保险费缴有效期不能为空!' },
  ]
}, {
  "text": "车架号",
  "field": "vehicleBaseObj_vin",//新增采销订单
  rules: [
    { required: true, message: '车架号不能为空!' },
    { max: 32, message: '车架号不能超过32个字符！' },
    validator.enNum
  ]
}, {
  "text": "使用性质",
  "field": "vehicleBaseObj_useProperty",//保存合同
  "category": "VEHICLE_USE_PROPERTY",
  "value": "A",
  select: true,
  needPull: true,
  rules: [
    { required: true, message: '使用性质不能为空!' },
  ]
}, {
  "text": "发动机号",
  "field": "vehicleBaseObj_engineNo",//保存合同
  rules: [
    { required: true, message: '发动机号不能为空!' },
    { max: 64, message: '发动机号不能超过16个字符！' },
    validator.lineEnNum
  ]
}, {
  "text": "钥匙数量",
  "field": "vehicleBaseObj_keyNum",//新增采销订单
  "value":2,
  rules: [
    { required: true, message: '钥匙数量不能为空!' },
    validator.num
  ]
}, {
  "text": "初登日期",
  "field": "vehicleBaseObj_registerDate",//新增采销订单
  date: true,
  rules: [
    { required: true, message: '初登日期不能为空!' },
  ]
}, {
  "text": "出厂日期",
  "field": "vehicleBaseObj_productionDate",//新增采销订单
  date: true
}, {
  "text": "评估价格",
  "field": "vehicleBaseObj_assessmentPrice"//新增采销订单
}, {
  "text": "车辆瑕疵说明",
  "field": "vehicleBaseObj_flawShow",//保存合同
}, {
  "text": "车身颜色",
  "field": "vehicleBaseObj_color",//保存合同
  "select": true,
  "category": "VEHICLE_COLOR",
  rules: [
    { required: true, message: '车身颜色不能为空!' },
  ]
}, {
  "text": "其他情况",
  "field": "vehicleBaseObj_remark",//新增采销订单
  // }, {
  //   "text": "OCR识别",
  //   "field": "vehicleOCR",
  //   iamge: true
}]

//交易信息
const dealField = [{
  "text": "交付时间",
  "field": "pickDateStr",//保存合同
  date: true,
  rules: [
    { required: true, message: '交付时间不能为空！' }
  ]
}, {
  "text": "提车地点",
  "field": "pickAddr",//保存合同
  "value": "厦门市集美区锦珩路2号",
  rules: [
    { required: true, message: '提车地点不能为空！' }
  ]
}, {
  "text": "车辆价格/元",
  "field": "totalAmount",//保存合同
  rules: [
    { required: true, message: '车辆价格不能为空！' },
    { pattern: /^[0-9.]+$/, message: '只能输入数字!' }
  ]
}, {
  "text": "支付模式",
  "field": "businessType",
  select: true,
  "value": "0",
  dictList: [{
    code: "0",
    name: '一次性付清',
  }, {
    code: "1",
    name: '先支付定金',
  }],
  rules: [
    { required: true, message: '支付模式不能为空！' }
  ]
}, {
  "text": "定金金额",
  "field": "deposit",//保存合同
  "value": 0,
  rules: [
    { pattern: /^[0-9.]+$/, message: '只能输入数字!' }
  ]
}, {
  "text": "其他费用",
  "field": "commissionAgree",//新增采销订单？？？
  "value": "过户费由买方承担，无其他杂费",
  rules: [
    { required: true, message: '其他费用不能为空！' }
  ]
}, {
  "text": "其他约定事项",
  "field": "otherMatters",//新增采销订单
  "textarea": true,
  "value": "卖方承诺该车无重大事故（包括但不限于A、B、C柱未见变形，车身骨架未受损伤等）、无泡水、非火烧车、无重大安全隐患，否则，买方有权无条件退车退款",
  rules: [
    { required: true, message: '约定事项不能为空！' }
  ]
}]

//买方信息
const buyer = [{
  "text": "证件类型",
  "field": "buyerCreditType",
  "category": "CREDIT_TYPE",
  select: true,
  value: "P1",
  rules: [
    { required: true, message: '证件类型不能为空!' }
  ]
}, {
  "text": "证件编号",
  "field": "buyerCreditNo",
  rules: [
    { required: true, message: '证件编号不能为空!' }
  ]
}, {
  "text": "买方姓名",
  "field": "buyerName",
  rules: [
    { required: true, message: '买方姓名不能为空!' },
    { max: 64, message: '买方姓名不能超过32个字符！' },
  ]
}, {
  "text": "联系电话",
  "field": "buyerTel",
  rules: [
    { required: true, message: '联系电话不能为空!' },
    validator.tel
  ]
}, {
  "text": "居住地址",
  "field": "buyerAddr",
  rules: [
    { required: true, message: '居住地址不能为空!' },
    { max: 128, message: '居住地址不能超过128个字符！' },
  ]
  // }, {
  //   "text": "OCR识别",
  //   "field": "buyerOCR",
  //   iamge: true
}];

//卖方信息
const seller = [{
  "text": "证件类型",
  "field": "sellerCreditType",
  "category": "CREDIT_TYPE",
  select: true
}, {
  "text": "证件编号",
  "field": "sellerCreditNo",
  rules: [
    { required: true, message: '证件编号不能为空!' }
  ]
}, {
  "text": "卖方姓名",
  "field": "sellerName",
  rules: [
    { required: true, message: '买方姓名不能为空!' },
    { max: 64, message: '买方姓名不能超过32个字符！' },
  ]
}, {
  "text": "联系电话",
  "field": "sellerPhone",
  rules: [
    { required: true, message: '联系电话不能为空!' },
    validator.tel
  ]
}, {
  "text": "居住地址",
  "field": "sellerAddress",
  rules: [
    { required: true, message: '居住地址不能为空!' },
    { max: 128, message: '居住地址不能超过128个字符！' },
  ]
}, {
  "text": "账户名称",
  "field": "payee",
  rules: [
    { required: true, message: '账户名称不能为空!' }
  ]
}, {
  "text": "开户行",
  "field": "bankOfDeposit",
  rules: [
    { required: true, message: '开户行不能为空!' }
  ]
}, {
  "text": "收款账户",
  "field": "bankAccounts",
  rules: [
    { required: true, message: '收款账户不能为空!' }
  ]
  // }, {
  //   "text": "OCR识别",
  //   "field": "sellerOCR",
  //   iamge: true
}];
class VehiclePurchaseEditForm extends Component {
  state = {
    activeKey: 'vehicle',
    loading: false,
    visible: false,
    dictSelect: {},
    is_deposit: true
  }

  componentDidMount() {
    if (this.props.initFunc) {
      this.props.initFunc(this.initEdit);
    }
  }

  initEdit = (editData) => {
    console.log('editData', editData)
    // let agency = editData.agency;
    // if (agency != null && agency !== "") {
    //   this.setState({ agency: agency });
    //   this.loadMemberUserInfo(agency);
    // }
    if(Number(editData['businessType'])&&Number(editData['businessType'])!==0){
      this.setState({is_deposit:false})
    }else{
      this.setState({is_deposit:true})
    }

    let image = editData.image;
    let fileList = {};
    let imageUrl = {};
    if (image != null) {
      for (var field in image) {
        if (image[field] != null && image[field] !== "") {
          fileList[field] = "data:image/jpeg;base64," + image[field].replace(/\r\n/g, "");
        }
      }
      imageUrl = editData.imageUrl;
    }
    let otherImages = editData.otherImages;
    let otherImagesUrl = [];
    let otherImage = [];
    if (otherImages != null && otherImages.length > 0) {
      for (let index in otherImages) {
        if (otherImages[index] != null && otherImages[index] !== "") {
          otherImage.push("data:image/jpeg;base64," + otherImages[index].replace(/\r\n/g, ""));
        }
      }
      otherImagesUrl = editData.otherImagesUrl;
    }
    this.setState({ editData:editData, fileList: fileList, otherImage: otherImage, imageUrl: imageUrl, otherImagesUrl: otherImagesUrl });

  }

  save = () => {
    const form = this.props.form;
    let queryData = this.props.queryData
    let saveOrderUrl = ''
    let vehicleOrderItemList_save = {}
    let orderid_save = {}
    let is_add = false
    console.log('this.state.editData',this.state.editData)
    if(this.state.editData&&JSON.stringify(this.state.editData)!='{}'){ // eslint-disable-line 
      saveOrderUrl = '/vehicleOrder/update'
      vehicleOrderItemList_save = this.state.editData.vehicleOrderItemList[0]
      orderid_save = {id:this.state.editData.id}
      is_add = false
    }else{
      is_add = true
      saveOrderUrl = '/vehicleOrder/add'
    }
    form.validateFields((err, values) => {
      console.log(values)
      if (err) {
        messager.notify("有未填写的必填项，请先填写完再保存！", "异常", "error");
        return;
      }
      this.setState({ loadingVisible: true });

      let obj = {
        vin: values.vehicleBaseObj_vin,
        plateNo: values.vehicleBaseObj_plateNo,
        owner: values.vehicleBaseObj_owner,
        address: values.sellerAddress,
        useProperty: values.vehicleBaseObj_useProperty,
        vehicleName: values.vehicleBaseObj_vehicleName,
        vehicleType: values.vehicleBaseObj_vehicleType,
        brandModel: values.vehicleBaseObj_vehicleName,
        engineNo: values.vehicleBaseObj_engineNo,
        registerDate: new Date(values.vehicleBaseObj_registerDate).toISOString().split('T')[0],
        issueDate: new Date(values.vehicleBaseObj_registerDate).toISOString().split('T')[0],
        registerNo: values.vehicleBaseObj_registerNo,
        productionDate: values.vehicleBaseObj_productionDate?new Date(values.vehicleBaseObj_productionDate).toISOString().split('T')[0]:'',
        color: values.vehicleBaseObj_color,
        mileage: values.vehicleBaseObj_mileage,
        remark: values.vehicleBaseObj_remark,
        price: values.totalAmount,
        examinationValidTime: new Date(values.vehicleBaseObj_examinationValidTime).toISOString().split('T')[0],
        commerciaInsuranceTime: values.vehicleBaseObj_commerciaInsuranceTime?new Date(values.vehicleBaseObj_commerciaInsuranceTime).toISOString().split('T')[0]:'',
        keyNum: values.vehicleBaseObj_keyNum,
        insurancePayTime: new Date(values.vehicleBaseObj_insurancePayTime).toISOString().split('T')[0],
        flawShow: values.vehicleBaseObj_flawShow,
        flawed:Number(Boolean(values.vehicleBaseObj_flawShow)),
        assessmentPrice:values.vehicleBaseObj_assessmentPrice
      }
      http.post({
        url: '/vehicleBase/saveVehicleBase',
        data: { 
          ...obj,
          // ...vehicleid_save
         },
        success: (r1) => {
          if (r1.success) {
            http.post({
              url: saveOrderUrl,
              data: {
                ...orderid_save,
                orderNo:this.state.editData.orderNo,
                orderType: queryData.orderType,
                flawed:Number(Boolean(values.vehicleBaseObj_flawShow)),
                ...values,
                pickDateStr: new Date(values.pickDateStr).toISOString().split('T')[0],
                item: JSON.stringify([{...vehicleOrderItemList_save,...obj}]),
                // orderType: 1
                // businessType: 1
              },
              success: (res) => {
                if(res.success){
                  this.props.successCallback();
                  this.props.onCancel();
                  messager.notify("保存成功！");
                  if(is_add){
                    http.post({
                      url: '/vehicleOrder/changeStatus',
                      data: {
                        orderType: queryData.orderType,
                        orderStatus: 2,
                        orderNo: res.data
                      }
                    })
                  }
                }else{
                  messager.alert(res.errorMessage, "异常保存", "error");
                }
                this.setState({ loadingVisible: false });
              },
              error: (res) => {
                this.setState({ loadingVisible: false });
                messager.alert(res, "异常保存", "error");
              }
            })
          }else{
            this.setState({ loadingVisible: false });
            messager.alert(r1.data.errorMessage, "异常保存", "error");
          }
        },
        error:(r1) =>{
          this.setState({ loadingVisible: false });
          messager.alert(r1.message, "异常保存", "error");
        }
      })
    });
  };
  transferData = (res, field) => {
    let value = res[field];
    for (let key in value) {
      res[field + "." + key] = value[key];
    }
    delete res[field];
  }
  //字典选择改变时触发
  dictSelect = (field, dict) => {
    if (dict != null) {
      const { form } = this.props;
      if (field === "agency") {
        form.setFieldsValue({
          "agentTel": dict.contactNumber,
          "agentMan": ""
        });
        this.setState({ agency: dict.code });
        this.loadMemberUserInfo(dict.code);
      } else if (field === "tradeVehicleType") {
        form.setFieldsValue({
          "commission": dict.des
        });
      }
    }
  }
  //swith选择改变时触发
  radioChange = (field, checked) => {
    if (field === "agent") {
      this.setState({ showAgent: checked });
      const { editData } = this.props;
      if (checked) {
        editData.agent = 1;
      } else {
        editData.agent = 0;
      }
    }
  }
  onRef = (field, dom) => {
    let dictSelect = this.state.dictSelect;
    dictSelect[field] = dom;
    this.setState({ dictSelect: dictSelect });
  }

  createDom = (data) => {
    let dom = [];
    for (let i = 0; i < data.length; i += 2) {
      let item = (<Row key={i}>
        <Col span={11}>
          {this.createDomItem(data[i])}
        </Col>
        <Col span={11} offset={2}>
          {(i + 1) < data.length ? this.createDomItem(data[i + 1]) : ''}
        </Col>
      </Row>);
      dom.push(item);
    }
    return dom;
  };
  createDomItem = (item) => {
    const { form, editData } = this.props;
    const { getFieldDecorator } = form;
    let domItem = "";
    let payState = editData.payState;
    if (item.agent === true && editData.agent === 0) {

    } else {
      domItem = (
        <FormItem label={item.text + "："}>
          {item.iamge ?
            <Image openScanner={this.showModal.bind(this, item.field)}
              onChange={this.handleUploadImage.bind(this, item.field)}
              type="button" />
            :
            getFieldDecorator(item.field, {
              rules: item.rules,
              initialValue:
                item.field=='deposit'&&editData['businessType']==0?0:item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field])) // eslint-disable-line 
                  : item.radio ? editData[item.field] === 1
                    : editData[item.field]!=null?editData[item.field].toString():item.value,
              valuePropName: item.radio ? 'checked' : 'value'
            })(
              item.select ?
                item.dictList ?
                <Select onSelect={this.onSelect.bind(this, item.field)} >
                    {item.dictList.map(d => <Select.Option key={d["code"]}>{d["name"]}</Select.Option>)}
                </Select> :
                  <DictSelect category={item.category} onSelect={item.onSelect ? this.dictSelect.bind(this, item.field) : null}
                    onRef={item.needPull === true ? this.onRef.bind(this, item.field) : null}
                    disabled={item.payState === true && payState === 1 && editData.agent === 0}
                  />
                : item.radio ?
                  // <Switch checkedChildren="是" unCheckedChildren="否" checked={this.state.radioCheck} onClick={(checked) => { this.setState({ radioCheck: checked }) }} />
                  <Switch checkedChildren="是" unCheckedChildren="否" onChange={this.radioChange.bind(this, item.field)} disabled={item.payState === true && payState === 1} />
                  : item.number ?
                    <InputNumber precision={2} min={0.00} style={{ width: '100%' }} />
                    : item.date ?
                      <DatePicker style={{ width: '100%' }} />
                      : item.member ? <MemberSelect onSelect={this.dictSelect.bind(this, item.field)} />
                        : item.memberUser ? <MemberUserSelect loadMemberUserInfo={(func) => this.loadMemberUserInfo = func} memberCode={this.state.agency} />
                          : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                            : item.field=='deposit'? <Input disabled={this.state.is_deposit} /> // eslint-disable-line
                            : <Input disabled={item.disabled === true} />
            )
          }
        </FormItem>
      );
    }
    return domItem;
  }

  createImageDom = (data) => {
    let dom = [];
    for (let i = 0; i < data.length; i++) {
      let item = data[i];
      let field = item.field;
      let file = this.state.fileList[field];
      dom.push(
        <Col span={4} key={field} style={{ height: '112px' }}>
          <Image
            openScanner={this.showModal.bind(this, field)}
            onChange={this.handleUploadImage.bind(this, field)}
            onRemove={this.handleRemoveImage.bind(this, field)}
            file={file}
            text={item.text}
            url={this.state.imageUrl[item.field]}
          />
        </Col>
      );
    }
    return dom;
  }
  createOtherImageDom = () => {
    let dom = [];
    let data = this.state.otherImage;
    let otherImagesUrl = this.state.otherImagesUrl;
    for (let i = 0; i <= data.length; i++) {
      let file = data[i];
      let url = i < otherImagesUrl.length ? otherImagesUrl[i] : null;
      dom.push(
        <Col span={4} key={i} style={{ height: '112px' }}>
          <Image
            openScanner={this.showModal.bind(this, "otherImage")}
            onChange={this.handleUploadImage.bind(this, "otherImage")}
            onRemove={this.handleRemoveImage.bind(this, "otherImage", i)}
            original={true}
            file={file}
            text={''}
            url={url}
          />
        </Col>
      );
    }
    return dom;
  }
  handleUploadImage = (field, { base64 }) => {
    if (field === "vehicleOCR") {
      //调用百度ocr识别
      ocr.baiduOCR({
        image: base64,
        imageType: 'VL',
        callback: (res) => {
          const { form } = this.props;
          let vehicleTypeList = this.state.dictSelect["vehicle.vehicleType"].state.dictList;
          let usePropertyList = this.state.dictSelect["vehicle.useProperty"].state.dictList;
          let useProperty = '';
          let vehicleType = '';
          if (vehicleTypeList != null && res["车辆类型"]["words"] != null) {
            for (let i = 0; i < vehicleTypeList.length; i++) {
              if (vehicleTypeList[i].name === res["车辆类型"]["words"]) {
                vehicleType = vehicleTypeList[i].code;
              }
            }
          }
          if (usePropertyList != null && res["使用性质"]["words"] != null) {
            for (let i = 0; i < usePropertyList.length; i++) {
              if (usePropertyList[i].name === res["使用性质"]["words"]) {
                useProperty = usePropertyList[i].code;
              }
            }
          }
          form.setFieldsValue({
            "vehicle.vin": res["车辆识别代号"]["words"].replaceAll("O","0").replaceAll("I","1"),
            "vehicle.brandModel": res["品牌型号"]["words"],
            "vehicle.brand": res["品牌型号"]["words"],
            "vehicle.model": res["品牌型号"]["words"],
            "vehicle.plateNo": res["号牌号码"]["words"],
            "vehicle.engineNo": res["发动机号码"]["words"],
            // "vehicle.vehicleType": res["车辆类型"]["words"],
            // "vehicle.useProperty": res["使用性质"]["words"]
            "vehicle.vehicleType": vehicleType,
            "vehicle.useProperty": useProperty,

            "seller.name": res["所有人"]["words"],
            "seller.residenceAddress": res["住址"]["words"],
          });
          this.setStateImageData(field, base64, res.url);
        },
        error: (res) => {
          this.setStateImageData(field, base64, res.url);
        }
      });
    } else if (field === "buyerOCR" || field === "sellerOCR") {
      const { form } = this.props;
      let imageType = "P1";
      if (field === "buyerOCR") {
        imageType = form.getFieldValue("buyer.creditType");
      } else {
        imageType = form.getFieldValue("seller.creditType");
      }
      //调用百度ocr识别
      ocr.baiduOCR({
        image: base64,
        imageType: imageType,
        idCardSide: 'front',
        callback: (res) => {
          if (imageType === "C3") {
            if (field === "buyerOCR") {
              form.setFieldsValue({
                "buyer.creditNo": res["社会信用代码"]["words"],
                "buyer.name": res["单位名称"]["words"],
                //"buyer.censusAddress": res["地址"]["words"],
                "buyer.residenceAddress": res["地址"]["words"],
              });
            } else {
              form.setFieldsValue({
                "seller.creditNo": res["社会信用代码"]["words"],
                "seller.name": res["单位名称"]["words"],
                //"seller.censusAddress": res["地址"]["words"],
                "seller.residenceAddress": res["地址"]["words"],
              });
            }
          } else {
            if (field === "buyerOCR") {
              form.setFieldsValue({
                "buyer.creditNo": res["公民身份号码"]["words"],
                "buyer.name": res["姓名"]["words"],
                //"buyer.censusAddress": res["住址"]["words"],
                "buyer.residenceAddress": res["住址"]["words"],
              });
            } else {
              form.setFieldsValue({
                "seller.creditNo": res["公民身份号码"]["words"],
                "seller.name": res["姓名"]["words"],
                //"seller.censusAddress": res["住址"]["words"],
                "seller.residenceAddress": res["住址"]["words"],
              });
            }
          }
          this.setStateImageData(field, base64, res.url);
        },
        error: (res) => {
          this.setStateImageData(field, base64, res.url);
        }
      });
    } else {
      //其他不需要ocr情况的直接将图片信息保留
      this.setStateImageData(field, base64, null);
    }

  };
  //将图片信息保存到state中
  setStateImageData(field, base64, url) {
    if (field === "otherImage") {
      const list = this.state.otherImage;
      list.push(base64);
      this.setState({ "otherImage": list });
    } else {
      const list = this.state.fileList;
      const imageUrl = this.state.imageUrl;
      if (field === "vehicleOCR") {
        list["vehicleLicense"] = base64;
        // delete imageUrl["vehicleLicense"];
        imageUrl["vehicleLicense"] = url;
      } else if (field === "buyerOCR") {
        list["buyerCreditFront"] = base64;
        // delete imageUrl["buyerCreditFront"];
        imageUrl["buyerCreditFront"] = url;
      } else if (field === "sellerOCR") {
        list["sellerCreditFront"] = base64;
        // delete imageUrl["sellerCreditFront"];
        imageUrl["sellerCreditFront"] = url;
      } else {
        list[field] = base64;
        delete imageUrl[field];
      }
      this.setState({ "fileList": list, "imageUrl": imageUrl });
    }

  }
  handleRemoveImage = (field, index) => {
    if (field === "otherImage") {
      const list = this.state.otherImage;
      const otherImagesUrl = this.state.otherImagesUrl;
      list.splice(index, 1);
      otherImagesUrl.splice(index, 1);
      this.setState({ "otherImage": list, "otherImagesUrl": otherImagesUrl });
    } else {
      const list = this.state.fileList;
      const imageUrl = this.state.imageUrl;
      delete list[field];
      delete imageUrl[field];
      this.setState({ "fileList": list, "imageUrl": imageUrl });
    }
  }
  showModal = (field) => {
    this.setState({ visible: true, imageField: field });
    this.state.initScanner();
  };
  hiddenModal = () => {
    this.setState({ visible: false });
  };
  handleScan = (base64) => {
    if (base64 != null && base64 !== "") {
      base64 = "data:image/jpeg;base64," + base64.replace(/\r\n/g, "");
      if (this.state.imageField === "otherImage") {
        const list = this.state.otherImage;
        list.push(base64);
        this.setState({ "otherImage": list });
      } else {
        // const list = this.state.fileList;
        // list[this.state.imageField] = base64;
        // this.setState({ "fileList": list });
        this.handleUploadImage(this.state.imageField, { base64 });
      }
    }
  }

  onSelect = (field, key) => {
    if (field === 'businessType') {
      if(key==='0'){
        const { form } = this.props;
        // let deposit = form.getFieldValue("deposit")
        form.setFieldsValue({
          deposit: 0,
        });
        this.setState({ is_deposit: true});
        // console.log(form.getField('deposit'))
      }else{
        this.setState({ is_deposit: false});
      }
      // const { form } = this.props;
      // console.log(field,key)
      // let deposit = form.getFieldValue("deposit")
      // console.log(deposit)
      // let sellerTax = calculationTax(true, key, this.props.editData.amount);
      
    }
  }

  render() {
    const { visible, onCancel } = this.props;
    return (
      <Modal
        width={1100}
        visible={visible}
        title="申请信息编辑"
        okText="保存"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
        //zIndex={1001}
        afterClose={() => {
          this.setState({ activeKey: 'vehicle' });
          this.props.form.resetFields();
        }}
      >
        <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
          <Tabs tabPosition='left' activeKey={this.state.activeKey}
            onChange={(activeKey) => {
              this.setState({ activeKey: activeKey });
            }}
          >
            <Tabs.TabPane tab="车辆信息" key="vehicle">
              {this.createDom(vehicleField)}
            </Tabs.TabPane>
            <Tabs.TabPane tab="交易信息" key="deal">
              {this.createDom(dealField)}
            </Tabs.TabPane>
            <Tabs.TabPane tab="买方信息" key="buyer">
              {this.createDom(buyer)}
            </Tabs.TabPane>
            <Tabs.TabPane tab="卖方信息" key="seller">
              {this.createDom(seller)}
            </Tabs.TabPane>
          </Tabs>

        </Form>
        <Scanner
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          initScanner={(func) => { this.setState({ initScanner: func }) }}
          onScan={this.handleScan}
        // successCallback={}
        />
        <Loading
          visible={this.state.loadingVisible}
          message="正在保存"
        />
      </Modal>
    );
  }

}

const VehiclePurchaseEdit = Form.create()(VehiclePurchaseEditForm);

export default VehiclePurchaseEdit;